import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const GetExpensesResponseDtoSchema = z.object({
  expenses: z.object({
    amount: z.number().nullable(),
    changePct: z.number().nullable(),
    // Staff from Sling: a month in the period has too few wages to show the cost.
    insufficientData: z.boolean().optional(),
    message: z.string().nullable().optional(),
  }),
  sparkline: z.object({
    granularity: z.string(),
    points: z.array(
      z.object({
        start: z.string(),
        end: z.string(),
        value: z.number().nullable(),
      })
    ),
  }),
});

const _GetExpensesRequestDtoSchema = z.object({
  from: z.string(),
  to: z.string(),
  facilitiesIds: z.array(z.number()).optional(),
});

export type GetExpensesRequestDto = z.infer<
  typeof _GetExpensesRequestDtoSchema
>;
export type GetExpensesResponseDto = z.infer<
  typeof GetExpensesResponseDtoSchema
>;

export const getExpenses = (
  params: GetExpensesRequestDto,
  config?: AxiosRequestConfig<GetExpensesRequestDto>
) => {
  return api
    .get('/facilities/expenses', { params, ...config })
    .then(responseContract(GetExpensesResponseDtoSchema));
};
